import { Component } from '@angular/core';
import { Events, IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';

import { AuthProvider } from '../../providers/auth/auth';
import { OrderProvider } from '../../providers/order/order';
import { ShopProvider } from '../../providers/shop/shop';

import { User } from "../../models/user.model";
import { Shop } from '../../models/shop.model';

import { fadeInOutAnimation } from '../../animations/fade-in-out';
import { PosmSubitem } from '../../models/posm-subitem.model';

@IonicPage()
@Component({
  selector: 'page-order',
  templateUrl: 'order.html',
  animations: [
    fadeInOutAnimation
  ]
})
export class OrderPage {

  user: User = new User;
  shop: Shop = new Shop;

  shopName: string;
  deliveryName: string;
  deliveryAddress: string;
  number: string;
  comments: string;

  posterUrl: string;
  isPrintable: boolean = false;

  posmSubitemId: number;
  posmSubitemQuantity: number;

  basketArray: Array<PosmSubitem>;

  editOrder: boolean = false;
  orderId: boolean;
  orderValidate: boolean;
  ordered: boolean = false;

  content: string;
  err: string;
  loading: boolean;

  orderType: "print" | "delivery";

  showAcceptBtn: boolean = false;

  constructor(public storage: Storage, public events: Events, public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, public translate: TranslateService, public authProvider: AuthProvider, public shopProvider: ShopProvider, public orderProvider: OrderProvider) {
    if (this.navParams.get('orderType'))
      this.orderType = this.navParams.get('orderType')
    else
      throw Error('Could not found the order type');

    if (this.orderType === 'print') {
      if (this.navParams.get('posmSubitemId')) {
        this.posmSubitemId = this.navParams.get('posmSubitemId');

        const posterUrl = this.navParams.get('posterUrl');
        if (posterUrl) {
          this.posterUrl = posterUrl;
          this.isPrintable = true;
        } else {
          throw Error('Call error, no poster url');
        }
      }
    } else {
      if (this.navParams.get('editOrder')) {
        this.editOrder = true;
        if (this.navParams.get('orderId')) {
          this.orderId = this.navParams.get('orderId');
          this.shopName = this.navParams.get('shopName') || '';
          this.deliveryName = this.navParams.get('deliveryName') || '';
          this.deliveryAddress = this.navParams.get('deliveryAddress') || '';
          this.number = this.navParams.get('number') || '';
          this.comments =  this.navParams.get('comments') || '';
        } else {
          throw Error('Call error, edit order but no id');
        }
      } else {
        if (this.navParams.get('basket')) {
          this.basketArray = this.navParams.get('basket');
        } else {
          throw Error('Call error, order but no subitems in the basket');
        }
      }
    }
  }

  closeModal() {
    this.navCtrl.pop();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  getInfos () {
    this.loading = true;
    this.authProvider.profile()
    .subscribe(
      user => {
        this.user = user;
      },
      error => {
        this.err = <any>error;
        this.loading = false;
      },
      () => {
        this.deliveryName = this.user.firstname + ' ' + this.user.lastname;
        this.loading = false;
        if (this.user.shop_id && !this.isPrintable) {
          this.loading = true;
          this.shopProvider.getByID(this.user.shop_id)
            .subscribe(
              shop => {
                this.shop = shop;
              },
              error => {
                this.err = <any>error;
              },
              () => {
                this.number = this.shop.number || '';
                this.shopName = this.shop.name || '';
                this.deliveryAddress = this.user.delivery_address ||
                ((this.shopName ? this.shopName + ' \n' : '')
                + (this.shop.address? this.shop.address + '\n ' : '')
                + (this.shop.zipcode? this.shop.zipcode + ', ' : '')
                + (this.shop.city? this.shop.city + '\n ' : '')
                + (this.shop.country_name? this.shop.country_name : ''));
                this.loading = false;
              }
            )
        };
      }
    );
  }

  orderDelivery() {
    this.loading = true;

    this.number = this.number.replace(/[^0-9]/g, '');

    if (!this.basketArray
      || !this.shopName
      || !this.deliveryName
      || !this.deliveryAddress
      || (!this.number || this.number.length != 10)
      )
      {
        this.orderValidate = false;
        this.loading = false;
    } else {
      if (!this.editOrder) {
        this.orderProvider.postDeliveryOrder({
          shopId: this.shop.id,
          basket: this.basketArray,
          shopName: this.shopName,
          deliveryName : this.deliveryName,
          deliveryAddress : this.deliveryAddress,
          comments: this.comments,
          number: this.number
        }).subscribe(
          res => {
            this.orderId = res;
            this.orderValidate = true;
          },
          error => {
            this.err = <any>error;
            this.orderValidate = false;
            this.loading = false;
          },
          () => {
            this.ordered = true;
            this.loading = false;
          }
        );
      } else {
        this.orderProvider.postEditOrder({
          orderId: this.orderId,
          shopName: this.shopName,
          deliveryName : this.deliveryName,
          deliveryAddress : this.deliveryAddress,
          comments: this.comments,
          number: this.number
        }).subscribe(
          res => {
            this.orderId = res;
            this.orderValidate = true;
          },
          error => {
            this.err = <any>error;
            this.orderValidate = false;
            this.loading = false;
          },
          () => {
            this.events.publish('orderList:get_data');
            this.ordered = true;
            this.loading = false;
          }
        );
      }
    }
  }

  orderEmail() {
    this.loading = true;
    if (!this.user.email || !this.posmSubitemId) {
      this.orderValidate = false;
      this.loading = false;
    } else {
      this.orderProvider.postEmailOrder({
        email: this.user.email,
        posmSubitemId: this.posmSubitemId
      }).subscribe(
        res => {
          this.orderValidate = res;
        },
        error => {
          this.err = <any>error;
          this.orderValidate = false;
          this.loading = false;
        },
        () => {
          this.ordered = true;
          this.loading = false;
        }
      );
    }
  }


  ionViewDidLoad() {
    if (!this.editOrder) {
      this.getInfos();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/order/order.ts